// apps/client/src/ui-kit/GlassCard.tsx
//
// Card component — V2 Beelucky Sweepstakes
// Variants: default (glass), glow (neon border), strong (opaque glass), white (solid white)
//

import React from 'react';
import { cn } from '../lib/utils';
import { motion, HTMLMotionProps } from 'framer-motion';

interface GlassCardProps extends HTMLMotionProps<'div'> {
    children: React.ReactNode;
    className?: string;
    variant?: 'default' | 'glow' | 'strong' | 'white';
}

export function GlassCard({ children, className, variant = 'default', ...props }: GlassCardProps) {
    return (
        <motion.div
            className={cn(
                'relative overflow-hidden rounded-3xl transition-all duration-300',
                // Variants
                variant === 'default' && 'glass-panel',
                variant === 'glow' && 'glass-panel shadow-neon-gold border-primary/50',
                variant === 'strong' && 'glass-panel-deep',
                variant === 'white' && 'bg-white border-white/30 shadow-card-white text-[#1A0B2E]',
                className
            )}
            {...props}
        >
            {/* Content */}
            <div className="relative z-10">
                {children}
            </div>
        </motion.div>
    );
}
